import { h, Fragment, Component } from "preact";
import { observer } from "mobx-react";
import {
  withStore,
  withController,
  Filter,
  useController,
} from "@searchspring/snap-preact-components";

@withStore
@withController
@observer
export class FilterSummary extends Component {
  render() {
    const controller = useController()

    const { filters } = controller.store
    const { facets } = controller.store

    const { urlManager } = controller

    const removeFilter = (e, filter) => {
        const query = `filter.${filter.field}`
        urlManager.remove(query, filter.value).go()
    }

    const clearAll = () => {
        urlManager.remove('filter').go()
    }

    let facetLabel;

      return (
        <div class="ss-summary">
            {filters.length > 0 && (
                <div class="clear-all">
                    <button onClick={clearAll}>Clear All</button>
                </div>
            )}
            <span class="active-filters">
                {filters.map(filter => {
                    return (
                      <div>
                        { facets.map(facet => {
                          if( facet.field == filter.field) {
                            facetLabel = facet.label;
                          } 
                        })}

                        <button onClick={e => removeFilter(e, filter)}>
                          <Filter
                              filter={filter}
                              facetLabel={facetLabel}
                              valueLabel={filter.label}
                              separator={': '}
                            />
                        </button>
          
                      </div>
                    )
                })}
            </span>
      </div>
    )
  }
}
